import { useSelector } from 'react-redux';
import { selectUser, selectIsAuthenticated, selectUserRole } from '../store/slices/authSlice';

export const useAuth = () => {
  const user = useSelector(selectUser);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const role = useSelector(selectUserRole);

  const isCustomer = role === 'customer';
  const isSeller = role === 'seller';
  const isAdmin = role === 'admin';

  return {
    user,
    isAuthenticated,
    role,
    isCustomer,
    isSeller,
    isAdmin,
  };
};